import { IGetAllGestaoRecebimentoEpiUseCase } from "../../../presentation/useCases/read/get_all_gestao_recebimento_epi_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";
import { GestaoRecebimentoEpi } from "../../models/gestao_recebimento_epi";



export class GetAllGestaoRecebimentoEpiUseCase
  extends BasePaginatedUseCase<GestaoRecebimentoEpi>
  implements IGetAllGestaoRecebimentoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {
    super();
  }

  async getAllGestaoRecebimentoEpi(
    idsGestaoEpi: number[] | null,
    idsFornecedores: number[] | null,
    ca: string | null,
    dataRecebimento: (Date | null)[] | null,
    dataValidade: (Date | null)[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const {
      items,
      totalItems,
      totalPages,
      currentPage,
      pageSize,
    } = await this.repository.getAllGestaoRecebimentoEpi(
      idsGestaoEpi,
      idsFornecedores,
      ca,
      dataRecebimento,
      dataValidade,
      page,
      rowsPerPage,
    );

    this._items = items;
    this._totalItems = totalItems;
    this._totalPages = totalPages;
    this._currentPage = currentPage;
    this._pageSize = pageSize;
  }
}
